import * as React from "react";
import {useMemo, useState} from "react";
import {RegisterForm} from "./Steps/RegisterForm/RegisterForm";
import {useAppSelector} from "../../app/hooks";
import {PasswordForm} from "./Steps/PasswordForm";
import {IRegisterForm} from "../../interface/Auth/frontend";

export const SignUp = () => {

    const {
        registerInitData,
    } = useAppSelector(state => state.auth)

    const initForm = useMemo(() => {
        if (registerInitData) {
            return {
                citizenshipId: registerInitData?.passportType.id ?? 1,
                name: registerInitData?.name ?? '',
                surname: registerInitData?.surname ?? '',
                patronymic: registerInitData?.patronymic ?? '',
                birthDate: registerInitData?.birthdate ?? null,
                passportSeries: registerInitData?.passportSeries ?? '',
                passportNumber: registerInitData?.passportNumber ?? '',
            }
        }
        return {
            citizenshipId: 1,
            name: '',
            surname: '',
            patronymic: '',
            birthDate: null,
            passportSeries: '',
            passportNumber: '',
        }
    }, [registerInitData])

    const [registerForm, setRegisterForm] = useState<IRegisterForm>(initForm)
    const [passwordCreate, setPasswordCreate] = useState(false)

    return <div className={'background body1'}>
        {passwordCreate
            ? <PasswordForm onGoBack={() => setPasswordCreate(false)}/>
            : <RegisterForm
                onSetPassword={() => setPasswordCreate(true)}
                registerForm={registerForm}
                setRegisterForm={form => setRegisterForm(form)}
                onResetForm={() => setRegisterForm(initForm)}/>}
    </div>
}
export default SignUp